import { PageRef } from 'providers/page-ref';

export enum IntakeStep {
  BasicInfo = 1,
  BodyComposition = 2,
  Strength = 3,
  Lifestyle = 4,
  AdvancedTraining = 5,
  Schedule = 6,
  NutritionOptions = 7,
  Goals = 8,
  TrainingVolume = 9,
  EnergyBalance = 10,
  ProgramOverview = 11,
  FirstWorkoutHandoff = 12
}

export enum IntakeStepUrl {
  BasicInfo = 'basic-info',
  BodyComposition = 'body-composition',
  Strength = 'strength',
  Lifestyle = 'lifestyle',
  AdvancedTraining = 'advanced-training',
  Schedule = 'schedule',
  NutritionOptions = 'nutrition-options',
  Goals = 'goals',
  TrainingVolume = 'training-volume',
  EnergyBalance = 'energy-balance',
  ProgramOverview = 'program-overview',
  FirstWorkoutHandoff = 'first-workout-handoff'
}

export type IntakeFormPageParams = {
  mode?: 'new' | 'change';
  tab?: IntakeStepUrl;
  coachClientSlotId?: string;
};

export const IIntakeFormPage: PageRef<IntakeFormPageParams, void> = {
  pageName: 'IntakeFormPage',
} as PageRef<IntakeFormPageParams, void>;

/**
 * The step total the intake header and stepper show (#6793). A client filling a coached
 * intake answers steps 1-8 (through Goals) and then waits for the coach, who does the rest,
 * so they see "of 8". Everybody else sees every step the page counted. The counted total
 * itself must stay as it is: the validation wizard numbers its step groups with it.
 */
export function displayedIntakeStepTotal(countedSteps: number, isCoachedOnboarding: boolean): number {
  return isCoachedOnboarding ? IntakeStep.Goals : countedSteps;
}
